module.exports = __webpack_public_path__ + "media/Video 94b.b47411d0.mp4";